import React, {Component} from 'react';
import "./TextBlock.css";

/**
 * TextBlock
 */
export default class TextBlock extends Component {

    createMarkup(text) {
        return {__html: text};
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const {title, text, textObject} = this.props;

        let text1 = '';
        let text2 = '';
        let text3 = '';
        let text4 = '';

        if (textObject) {
            text1 = textObject.text1;
            text2 = textObject.text2;
            text3 = textObject.text3;
            text4 = textObject.text4;
        }

        return (
            <div className="textblock">
                <h1>{title}</h1>
                <hr/>
                <div>
                    {text &&
                    <p dangerouslySetInnerHTML={this.createMarkup(text)} />}

                    {textObject &&
                    <p>{text1}<br/>{text2}<br/>{text3}<br/>{text4}</p>}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TextBlock/TextBlock.jsx